"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonSchemaParser = void 0;
const tslib_1 = require("tslib");
const lodash_isnil_1 = tslib_1.__importDefault(require("lodash.isnil"));
const lodash_isstring_1 = tslib_1.__importDefault(require("lodash.isstring"));
const react_1 = tslib_1.__importDefault(require("react"));
class JsonSchemaParser {
    constructor(getComponent = () => null) {
        this.getComponent = getComponent;
        //
    }
    parseSchema(schema) {
        if (Array.isArray(schema)) {
            return this.parseSubSchemas(schema);
        }
        return this.createComponent(schema);
    }
    parseSubSchemas(subSchemas = []) {
        const Components = [];
        let index = 0;
        let subSchema;
        for (subSchema of subSchemas) {
            subSchema.props = subSchema.props || {};
            subSchema.props.key = subSchema.props.key || String(index);
            const Component = this.parseSchema(subSchema);
            Components.push(Component);
            index++;
        }
        return Components;
    }
    createComponent(node) {
        const { text, props, component } = node;
        if (lodash_isnil_1.default(component)) {
            throw Error('Could not parse React JSON Schema. Reason: "component" property is required, but not given.');
        }
        const Component = this.resolveComponent(node);
        const Children = text || this.resolveComponentChildren(node);
        return react_1.default.createElement(Component, props, Children);
    }
    resolveComponent(node) {
        const { component } = node;
        // component is already a react component
        if (!lodash_isstring_1.default(component) && component === Object(component)) {
            return component;
        }
        const Component = this.getComponent(node);
        if (!Component) {
            throw Error(`Could not parse React JSON Schema. Reason: Could not resolve component: ${component}.`);
        }
        return Component;
    }
    resolveComponentChildren({ children, }) {
        return !lodash_isnil_1.default(children) ? this.parseSchema(children) : undefined;
    }
}
exports.JsonSchemaParser = JsonSchemaParser;
